import * as S from './ProductTaggingSearchModal.style';
import { useStyles } from '@archipro-design/aria';
import React, { useState } from 'react';
import { useProductTagging } from '@modules/product-tagging/context';
import { SupplierSearchForm } from '@modules/product-tagging/components/product-tagging-search/SupplierSearchForm';
import { ProductSearchForm } from '@modules/product-tagging/components/product-tagging-search/ProductSearchForm';
import type {
    SearchFormType,
    TagDataUseToCreateTag,
} from '@modules/product-tagging/type';
import type { State } from '@popperjs/core';

interface ProductSearchModalProps {
    onCreateMarker: (data: TagDataUseToCreateTag) => void;
    popperState: State | null;
}

const ProductTaggingSearchModal = ({
    onCreateMarker,
    popperState,
}: ProductSearchModalProps) => {
    const [formType, setFormType] = useState<SearchFormType>('product');
    const { dispatch } = useProductTagging();
    const { css } = useStyles();

    return (
        <div className={css(S.ProductSearchModal)}>
            {formType === 'product' ? (
                <ProductSearchForm
                    onFormToggle={(type) => setFormType(type)}
                    onConfirm={onCreateMarker}
                    popperState={popperState}
                />
            ) : (
                <SupplierSearchForm
                    onClickButton={() =>
                        dispatch({
                            type: 'TOGGLE_ADDING_SUPPLIER',
                            payload: true,
                        })
                    }
                    onConfirm={onCreateMarker}
                />
            )}
        </div>
    );
};

export default ProductTaggingSearchModal;
